import routes from './routes';
import { SetRoutes } from 'components';

const MainPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default MainPages;
